/**
 * aswbe checkin eapi
 * チェックイン業務で利用するAPIを提供する
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 1便目のチェックイン可否判定オブジェクト
 */
export interface PostJourneysGetJourneyResponseDataTravelersInnerFirstFlightAcceptanceEligibility {
  /**
   * チェックイン可否（判定条件はreason項目を参照）<br> eligible: チェックイン可<br> ineligible: チェックイン不可
   */
  status: PostJourneysGetJourneyResponseDataTravelersInnerFirstFlightAcceptanceEligibility.StatusEnum;
  /**
   * チェックイン不可理由（チェックイン不可の場合のみ）    |No|条件|チェックイン不可理由の値|   |---:|:---|:---|   |1|DxAPIによるチェックイン可否の判定の結果、1便目となるセグメントがチェックイン不可であり、かつ入国関連情報を登録してもチェックイン可とならないチェックイン不可理由である<br>※Flight Acceptance Status Timing Rule、Self Service Flight Eligibility Rule、Self Service Customer Eligibility Ruleなどのルール範囲外である場合を含む。|dxapiAcceptanceEligibility|   |2|journey内に1便でもNHグループ運航NHグループ便名、かつ席あり幼児を制限しているACV・キャビンクラスで、搭乗者に席あり幼児（INS）が存在する|containedInfantWithSeatRestrictedFlight|   |3|1便でも未発券のセグメントが存在する搭乗者である|unticketed|   |4|複数チェックイン対象便があり、1便目が未チェックインにも関わらず、2便目以降がチェックイン済みである<br>もしくは、複数チェックイン対象便があり、未チェックインが間に存在する|checkInOrder|   |5|SKにPRIS/ARMDのいずれかが存在する|checkInSk|   |6|搭乗者がHigh Priority制限を保持し、かつ以下のいずれかに該当する<br>1. Acceptance comment(ACC)が登録されている<br>2. Next comment(NXT)が登録されている|highPriority|   |7|SSR EXSTまたはSSR CBBGが存在する|seatSsr|   |8|Altea Web Serviceによるチェックイン順序チェックの結果、チェックイン不可である|sequenceCheckState|
   */
  reason?: PostJourneysGetJourneyResponseDataTravelersInnerFirstFlightAcceptanceEligibility.ReasonEnum;
  /**
   * DxAPIから返却された1便目のチェックイン不可理由のリスト（DxAPIの判定でチェックイン不可の場合のみ）<br> チェックイン不可理由の例（抜粋）<br> \"firstFlightOtherAirline\"<br> \"flightGeneralStatus\"<br> \"ticketProblem\"
   */
  dxapiReasons?: Array<string>;
}
export namespace PostJourneysGetJourneyResponseDataTravelersInnerFirstFlightAcceptanceEligibility {
  export type StatusEnum = 'eligible' | 'ineligible';
  export const StatusEnum = {
    Eligible: 'eligible' as StatusEnum,
    Ineligible: 'ineligible' as StatusEnum,
  };
  export type ReasonEnum =
    | 'dxapiAcceptanceEligibility'
    | 'containedInfantWithSeatRestrictedFlight'
    | 'unticketed'
    | 'checkInOrder'
    | 'checkInSk'
    | 'highPriority'
    | 'seatSsr'
    | 'sequenceCheckState';
  export const ReasonEnum = {
    DxapiAcceptanceEligibility: 'dxapiAcceptanceEligibility' as ReasonEnum,
    ContainedInfantWithSeatRestrictedFlight: 'containedInfantWithSeatRestrictedFlight' as ReasonEnum,
    Unticketed: 'unticketed' as ReasonEnum,
    CheckInOrder: 'checkInOrder' as ReasonEnum,
    CheckInSk: 'checkInSk' as ReasonEnum,
    HighPriority: 'highPriority' as ReasonEnum,
    SeatSsr: 'seatSsr' as ReasonEnum,
    SequenceCheckState: 'sequenceCheckState' as ReasonEnum,
  };
}
